module.exports = __webpack_public_path__ + "img/fp-info-unfolded.c74e89d4.webp";